<template>
  <div class="flex-column">

    <div class="app-container flex-item">
      <el-row style="height: 100%;">
        <el-col :span="4" style="height: 100%;">
          <div class="bg-white" style="height: 100%;">

            <el-card shadow="never" class="body-small" style="height: 100%;overflow:auto;">
              <div slot="header" class="clearfix">
                <el-button type="text" style="padding: 0 11px">当前用户可访问的菜单</el-button>
              </div>

              <el-tree :data="modulesTree" :expand-on-click-node="false" default-expand-all :props="orgTreeProps">
              </el-tree>
            </el-card>
          </div>
        </el-col>
        <el-col :span="20" style="height: 100%;">
          <div class="bg-white" style="height: 100%;">
            <el-card shadow="never" class="body-small" style="height: 100%;overflow:auto;">
              <div slot="header" class="clearfix">
                <el-button type="text" style="padding: 0 11px">基本资料</el-button>
              </div>
              <el-form ref="dataForm" :model="temp" label-position="right" label-width="100px">
                <el-form-item size="small" :label="'账号'" prop="account">
                  <span>{{ temp.account }}</span>
                </el-form-item>

                <el-form-item size="small" :label="'姓名'" prop="name">
                  <el-input v-model="temp.name" disabled></el-input>
                </el-form-item>
                <!-- <el-form-item size="small" :label="'性别'">
                  <el-radio v-model="temp.sex" :label="0">男</el-radio>
                  <el-radio v-model="temp.sex" :label="1">女</el-radio>
                </el-form-item> -->
                <el-form-item size="small" :label="' '">
                  <!-- <el-button size="mini" type="primary" @click="changeProfile">确认修改</el-button> -->
                </el-form-item>
              </el-form>
              <el-form ref="dataForm" :model="temp" label-position="right" label-width="100px">
                <el-form-item size="small" :label="'新密码'" prop="name">
                  <el-input v-model="newpwd" show-password></el-input>
                  <div style="color: red; font-size: 14px;">密码必须由大写字母、小写字母、数字、特殊符号中的2种及以上类型组成!</div>
                </el-form-item>
                <el-form-item size="small" :label="'确认新密码'" prop="name">
                  <el-input v-model="newpwd1" show-password></el-input>

                </el-form-item>
                <el-form-item size="small" :label="' '">
                  <el-button size="mini" type="primary" @click="changePassword">确认修改</el-button>
                </el-form-item>
              </el-form>


            </el-card>
          </div>

        </el-col>

        <!-- <el-col :span="5" style="height: 100%;border: 1px solid #EBEEF5;">
          <el-card shadow="never" class="body-small" style="height: 100%;overflow:auto;">
            <div slot="header" class="clearfix">
              <el-button type="text" style="padding: 0 11px">可访问的机构（✅为当前默认,点击可切换）</el-button>
            </div>

            <el-tree :data="orgsTree" :expand-on-click-node="false" default-expand-all :props="orgTreeProps"
              @node-click="handleNodeClick"></el-tree>
          </el-card>
        </el-col> -->

      </el-row>

    </div>
  </div>
</template>

<script>
import {
  listToTreeSelect
} from '@/utils'
import * as login from '@/api/login'
import * as users from '@/api/users'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import waves from '@/directive/waves' // 水波纹指令
import {
  mapGetters
} from 'vuex'
import store from '@/store'

export default {
  name: 'profile',
  components: {},
  directives: {
    waves
  },
  data() {
    return {
      orgTreeProps: { // tree配置项
        children: 'children',
        label: 'label'
      },
      listLoading: true,
      orgs: [], // 用户可访问到的组织列表
      orgsTree: [], // 用户可访问到的所有机构组成的树

      modules: [],
      modulesTree: [], // 用户可访问的所有模块组成的树

      temp: {
        account: '',
        name: '',
        sex: 0
      },
      newpwd: '',
      newpwd1: ''
    }
  },
  computed: {
    ...mapGetters(['defaultorgid', 'name'])
  },
  filters: {

  },
  mounted() {
    this.getUserProfile()
    this.getOrgTree()
    this.getModulesTree()
  },
  created() {

    let url = JSON.parse(window.localStorage.getItem('returnUrl')) || ''
    if (url == '/profile') {
      this.$message.error('当前登录账号密码过于简单,不修改密码使用不了菜单,请修改密码后重新登录!')
    }
  },
  methods: {
    changeProfile() {
      const _this = this
      users.changeProfile(this.temp).then(response => {
        _this.$message({
          message: response.message,
          type: 'success'
        })
      })
    },

    changePassword() {
      this.pswPudate()


    },

    handleNodeClick(data) {
      store.commit('SET_DEFAULTORG', data)
      this.getOrgTree()
    },

    getUserProfile() {
      var _this = this // 记录vuecomponent
      login.getUserProfile().then(response => {
        _this.temp = response.result
      })
    },

    getModulesTree() {
      var _this = this // 记录vuecomponent
      login.getModules().then(response => {
        _this.modules = response.result.map(function (item) {
          return {
            id: item.id,
            label: item.name,
            parentId: item.parentId
          }
        })
        var tmp = JSON.parse(JSON.stringify(_this.modules))
        _this.modulesTree = listToTreeSelect(tmp)
      })
    },

    getOrgTree() {
      var _this = this // 记录vuecomponent
      login.getOrgs().then(response => {
        _this.orgs = response.result.map(function (item) {
          var name = item.name
          if (_this.defaultorgid === item.id) {
            name = name + '✅'
          }
          return {
            id: item.id,
            label: name,
            parentId: item.parentId
          }
        })
        var orgstmp = JSON.parse(JSON.stringify(_this.orgs))
        _this.orgsTree = listToTreeSelect(orgstmp)
      })
    },
    checkPasswordComplexity(password) {
      // 定义正则表达式规则
      const regex = /(?![A-Z]*$)(?![a-z]*$)(?![0-9]*$)(?![^a-zA-Z0-9]*$)/;

      // 判断密码是否符合规则
      if (regex.test(password)) {
        return true;
      } else {
        return false;
      }
    },
    pswPudate() {
      console.log(this.newpwd)
      const isComplex = this.checkPasswordComplexity(this.newpwd);

      if (isComplex) {
        if (this.newpwd == this.newpwd1) {
          console.log("密码复杂度符合要求");
          const _this = this
          users.changePassword({
            account: _this.temp.account,
            password: _this.newpwd
          }).then(response => {
            _this.$message({
              message: response.message,
              type: 'success'
            })
            setTimeout(() => {
              this.$store.dispatch('LogOut').then(() => {
                location.reload() // 为了重新实例化vue-router对象 避免bug
              })
              window.localStorage.removeItem('Currentdepartment');
              window.localStorage.removeItem('department');
              window.localStorage.removeItem('username');
              window.localStorage.removeItem('modules');
              window.localStorage.removeItem('routers');
              window.localStorage.removeItem('MsgArrayTotal');
              window.localStorage.removeItem('returnUrl');
              window.localStorage.removeItem('MsgArray');
            }, 1000);
          })
        } else {
          this.$message.error('密码不一致！')
        }

      } else {
        this.$message.error('密码必须由大写字母、小写字母、数字、特殊符号中的2种及以上类型组成!')
        // this.newpwd=''
      }


    }


  }
}

</script>

<style scoped>
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}

.el-select.filter-item.el-select--small {
  width: 100%;
}
</style>
